module.exports = __webpack_public_path__ + "static/naufal-denmark-18a8063b19bca9e5ce217b51f323353e.jpg";